import { dbPromise } from "./db"

const TEAMS_CACHE_KEY = "attendances_teams"

export async function saveTeamsCache(teams) {
  if (!teams) return
  const db = await dbPromise
  await db.put("teams_cache", {
    key: TEAMS_CACHE_KEY,
    teams,
    savedAt: new Date().toISOString()
  })
}

export async function getTeamsCache() {
  const db = await dbPromise
  try {
    const record = await db.get("teams_cache", TEAMS_CACHE_KEY)
    return record?.teams || null
  } catch {
    return null
  }
}

export async function getCachedTeam(teamId) {
  const teams = await getTeamsCache()
  if (!teams) return null
  const key = String(teamId)
  return teams[key] || null
}

export async function updateTeamInCache(teamId, updates) {
  const teams = await getTeamsCache()
  if (!teams) return
  const key = String(teamId)
  if (!teams[key]) return
  teams[key] = { ...teams[key], ...updates }
  await saveTeamsCache(teams)
}

